import axios from 'axios';

/**
 * Retrieve the config of the order-form from the confirmation page
 * @returns {Promise}
 */
const getOrderFormConfigFile = function (mutations) {
  return new Promise((resolve, reject) => {
    if (this.$store.getters.orderFormConfig !== null) {
      return resolve();
    }

    axios.get('../order-form/config.json').then(response => {
      if (!response || !response.data) {
        const message = 'Unable to read order-form config file';
        this.$log.error(message, response);
        reject(message);
        return;
      }

      this.$store.commit(mutations.SET_ORDER_FORM_CONFIG, response.data);
      resolve();
    }, error => {
      const message = 'Unable to retrieve order-form config file';
      this.$log.error(message, error);
      reject(message);
    });
  });
};

const configs = {
  getOrderFormConfigFile
};

export default configs;



// WEBPACK FOOTER //
// ./src/multiple/services/configs.js